<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.3163 4.00024H22.6837C24.5153 4.00024 26 5.48499 26 7.31652V10.684C26 12.5155 27.4847 14.0002 29.3163 14.0002H32.6837C34.5153 14.0002 36 15.485 36 17.3165V22.684C36 24.5155 34.5153 26.0002 32.6837 26.0002H29.3163C27.4847 26.0002 26 27.485 26 29.3165V32.684C26 34.5155 24.5153 36.0002 22.6837 36.0002H17.3163C15.4847 36.0002 14 34.5155 14 32.684V29.3165C14 27.485 12.5153 26.0002 10.6837 26.0002H7.31627C5.48475 26.0002 4 24.5155 4 22.684V17.3165C4 15.485 5.48475 14.0002 7.31628 14.0002H10.6837C12.5153 14.0002 14 12.5155 14 10.684V7.31652C14 5.48499 15.4847 4.00024 17.3163 4.00024ZM19.9995 27.0014L14.9876 21.8304C13.7938 20.5987 13.4973 18.7522 14.2453 17.2086C15.0629 15.5214 17.1912 14.9586 18.7359 16.0212L19.9995 16.8903L21.2631 16.0212C22.8079 14.9586 24.9362 15.5214 25.7538 17.2086C26.5018 18.7522 26.2052 20.5987 25.0115 21.8304L19.9995 27.0014Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsVerticalsHomeHealth'
})

defineProps({
  width: {
    type: String,
    default: '40'
  },

  height: {
    type: String,
    default: '40'
  },
  fill: {
    type: String,
    default: semanticColorLookup('surface.on-surface')
  }
})
</script>
